/* eslint-disable*/
import Validators from './validators';
import email from './email';
import url from './url';
import numericality from './numericality';
import dateAcross from './dateAcross';
import dropdownAcross from './dropdownAcross';
import maxLengthAfterDecimalPoint from './maxLengthAfterDecimalPoint';
import requiredDefaultLanguage from './requiredDefaultLanguage';
import multiLanguageLength from './multiLanguageLength';
import time from './time';
import currency from './currency';
import requiredMultiSelectDropDownValue from './requiredMultiSelectDropDownValue';
import guid from './guid';
import phone from './phone';
import booleanRequired from './booleanRequired';
import range from './range';
import rangeRequired from './rangeRequired';
import requiredRange from './requiredRange';
import absence from './absence';
import acceptance from './acceptance';
import confirmation from './confirmation';
import date from './date';
import exclusion from './exclusion';
import format from './format';
import presence from './presence';
import length from './length';
import inclusion from './inclusion';
import file from './file';
import regexEvery from './regexEvery';
import hex from './hex';
import fileUploaderNameLength from './fileUploaderNameLength';
import addValidator from './add-validator';

let required = presence; // alias

export const MAX_INT32_VALUE = 2147483647;

export {
	required,
	email,
	numericality,
	date,
	length,
	confirmation,
	format,
	acceptance,
	inclusion,
	exclusion,
	absence,
	url,
	file,
	dateAcross,
	maxLengthAfterDecimalPoint,
	requiredDefaultLanguage,
	multiLanguageLength,
	time,
	currency,
	requiredMultiSelectDropDownValue,
	guid,
	phone,
	booleanRequired,
	regexEvery,
	range,
	rangeRequired,
	requiredRange,
	hex,
	fileUploaderNameLength,
	addValidator,
	dropdownAcross,
};

export default Validators;

export { composeValidators } from './utils';
